const initShopDetails = () => {
  const tabsContainer = document.querySelector('.js-go-to-top-pos .tabs.wc-tabs');
  
  if (!tabsContainer) {
    return;
  }

  const tabs = tabsContainer.querySelectorAll('li[role="presentation"]');
  const goToTopBtn = document.querySelector('.s-product-detail .go_to_top_tab a');
  
  // Track active tab keys for scroll-based highlighting
  let currentActiveTabKey = null; // Track the currently active tab
  let previousActiveTabKey = null; // Track the previous active tab

  // Handle go to top button click
  if (goToTopBtn) {
    goToTopBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const targetElement = jQuery(".js-go-to-top-pos").first();
      jQuery(window).scrollTop(targetElement.position().top - 150);
    });
  }

  // Map tab keys to their corresponding section selectors
  const tabSectionMap = {
    'description': '#tab-description',
    'additional_information': '#tab-additional_information',
    'reviews': '#tab-reviews',
    'user_comments': '#custom-comments',
    'go_to_top': '.js-go-to-top-pos'
  };

  // Helper function to get tab key from various attributes
  const getTabKey = (tab) => {
    // Try className first (existing method)
    let tabKey = tab.className.replace('_tab', '').trim();
    if (tabKey && tabSectionMap[tabKey]) {
      return tabKey;
    }
    
    // Try to match by id on tab element (e.g., id="tab-user_comments")
    if (tab.id) {
      const idKey = tab.id.replace('tab-', '').replace('-tab', '').replace(/^tab-/, '');
      if (tabSectionMap[idKey]) {
        return idKey;
      }
    }
    
    // Try to match by aria-controls on tab element
    const tabAriaControls = tab.getAttribute('aria-controls');
    if (tabAriaControls) {
      const ariaKey = tabAriaControls.replace('tab-', '').replace('-tab', '').replace(/^tab-/, '');
      if (tabSectionMap[ariaKey]) {
        return ariaKey;
      }
    }
    
    // Try to match by aria-controls on the link (e.g., aria-controls="tab-user_comments")
    const tabLink = tab.querySelector('a');
    if (tabLink) {
      const ariaControls = tabLink.getAttribute('aria-controls');
      if (ariaControls) {
        const ariaKey = ariaControls.replace('tab-', '').replace('-tab', '').replace(/^tab-/, '');
        if (tabSectionMap[ariaKey]) {
          return ariaKey;
        }
      }
      
      // Try to match by href (e.g., href="#tab-user_comments")
      const href = tabLink.getAttribute('href');
      if (href) {
        const hrefKey = href.replace('#tab-', '').replace('#', '').replace('-tab', '').replace(/^tab-/, '');
        if (tabSectionMap[hrefKey]) {
          return hrefKey;
        }
      }
    }
    
    return tabKey; // Return original if no match found
  };

  // Handle tab clicks for smooth scrolling
  tabs.forEach(tab => {
    const tabLink = tab.querySelector('a');
    if (!tabLink) return;

    const tabKey = getTabKey(tab);
    const sectionSelector = tabSectionMap[tabKey];

    if (sectionSelector && tabKey !== 'go_to_top') {
      tabLink.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Update active state immediately
        tabs.forEach(t => {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        
        // Update the tracked active tab keys
        previousActiveTabKey = currentActiveTabKey;
        currentActiveTabKey = tabKey;

        // Scroll to the section
        const section = document.querySelector(sectionSelector);
        if (section) {
          const tabsBar = document.querySelector('.js-go-to-top-pos .tabs.wc-tabs');
          const headerOffset = 150; // Account for sticky header/tabs
          const tabsBarOffset = tabsBar ? tabsBar.offsetHeight : 0;
          const totalOffset = headerOffset + tabsBarOffset;
          
          // Get element position relative to document
          const elementPosition = section.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - totalOffset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });

          // Update hash without triggering scroll
          if (history.pushState) {
            const hash = tabLink.getAttribute('href');
            history.pushState(null, null, hash);
          }
        }
      });
    }
  });

  // Scroll-based highlighting
  const highlightActiveTab = () => {
    const scrollPosition = window.pageYOffset;
    const tabsBar = document.querySelector('.js-go-to-top-pos .tabs.wc-tabs');
    const offset = tabsBar ? tabsBar.offsetHeight + 100 : 150;
    
    // Outer margin: offset before the top of each section to trigger active state
    // Adjust this value to control when tabs become active (in pixels)
    const sectionOuterMargin = 100; // You can change this value

    // Find the section that's currently in view
    let activeTabKey = null;

    // Get all sections with their positions
    const sections = [];
    Object.keys(tabSectionMap).forEach(key => {
      const selector = tabSectionMap[key];
      if (!selector || key === 'go_to_top') return;

      const section = document.querySelector(selector);
      if (!section) return;

      const rect = section.getBoundingClientRect();
      const sectionTop = rect.top + scrollPosition;
      const sectionBottom = sectionTop + rect.height;

      sections.push({
        key,
        top: sectionTop,
        bottom: sectionBottom,
        element: section
      });
    });

    // Sort sections by their top position (from top to bottom)
    sections.sort((a, b) => a.top - b.top);

    // Find which section is currently in the viewport (checking from bottom to top)
    const viewportTop = scrollPosition + offset;
    
    // Check sections in reverse order to find the last one that has started
    for (let i = sections.length - 1; i >= 0; i--) {
      const section = sections[i];
      
      // Calculate trigger point with outer margin (top of section - outer margin)
      // This makes the tab activate before reaching the section
      const triggerPoint = section.top - sectionOuterMargin;
      
      // If we've scrolled past the trigger point (top - outer margin), it's the active one
      if (viewportTop >= triggerPoint) {
        activeTabKey = section.key;
        break;
      }
    }

    // If no section found, default to the first section
    if (!activeTabKey && sections.length > 0) {
      activeTabKey = sections[0].key;
    }

    // Only update DOM if the active tab has changed (user entered a new section)
    if (activeTabKey !== currentActiveTabKey) {
      // Separate logic: Remove active class from previous tab
      if (previousActiveTabKey !== null) {
        tabs.forEach(tab => {
          const tabKey = getTabKey(tab);
          if (tabKey === previousActiveTabKey) {
            tab.classList.remove('active');
            tab.setAttribute('aria-selected', 'false');
          }
        });
      }
      
      // Separate logic: Add active class to new tab
      tabs.forEach(tab => {
        const tabKey = getTabKey(tab);
        if (tabKey === activeTabKey) {
          tab.classList.add('active');
          tab.setAttribute('aria-selected', 'true');
        }
      });
      
      // Update tracked tab keys
      previousActiveTabKey = currentActiveTabKey;
      currentActiveTabKey = activeTabKey;
    }
  };

  // Throttle scroll event for better performance
  let scrollTimeout;
  const handleScroll = () => {
    if (scrollTimeout) {
      cancelAnimationFrame(scrollTimeout);
    }
    scrollTimeout = requestAnimationFrame(highlightActiveTab);
  };

  // Initial check
  highlightActiveTab();

  // Listen to scroll events
  window.addEventListener('scroll', handleScroll, { passive: true });
}

export {initShopDetails}